import React from 'react';

// Event category and severity types from backend
const Severity = {
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  WARNING: 'WARNING',
  INFO: 'INFO',
  UNKNOWN: 'UNKNOWN'
};

const Category = {
  ALARM: 'ALARM',
  SYSTEM: 'SYSTEM',
  MAINTENANCE: 'MAINTENANCE',
  POWER: 'POWER',
  COMMUNICATION: 'COMMUNICATION',
  DEVICE: 'DEVICE',
  VIDEO_ALARM: 'VIDEO_ALARM',
  ACCESS: 'ACCESS',
  DURESS: 'DURESS'
};

const EventDetailsCell = ({ event }) => {
  // Function to determine severity from event
  const getSeverity = () => {
    if (event.severity) return event.severity;
    
    // Default severity based on category if available
    if (event.category === 'VIDEO_ALARM') return Severity.HIGH;
    if (event.category === 'ALARM') return Severity.HIGH;
    if (event.category === 'DURESS') return Severity.HIGH;
    
    return Severity.UNKNOWN;
  };

  // Function to get category from event
  const getCategory = () => {
    return event.category || 'UNKNOWN';
  };

  // Get event details
  const severity = getSeverity();
  const category = getCategory();
  
  // Function to get severity badge styling
  const getSeverityStyle = (severity) => {
    switch(severity) {
      case Severity.HIGH:
        return 'bg-red-100 text-red-800 border border-red-200';
      case Severity.MEDIUM:
        return 'bg-orange-100 text-orange-800 border border-orange-200';
      case Severity.WARNING:
        return 'bg-yellow-100 text-yellow-800 border border-yellow-200';
      case Severity.INFO:
        return 'bg-green-100 text-green-800 border border-green-200';
      default:
        return 'bg-gray-100 text-gray-800 border border-gray-200';
    }
  };
  
  // Function to get category badge styling
  const getCategoryStyle = (category) => {
    switch(category) {
      case Category.ALARM:
        return 'bg-red-50 text-red-700 border border-red-100';
      case Category.VIDEO_ALARM:
        return 'bg-purple-50 text-purple-700 border border-purple-100';
      case Category.DURESS:
        return 'bg-red-50 text-red-700 border border-red-100';
      case Category.POWER:
        return 'bg-amber-50 text-amber-700 border border-amber-100';
      case Category.COMMUNICATION:
        return 'bg-blue-50 text-blue-700 border border-blue-100';
      case Category.SYSTEM:
        return 'bg-indigo-50 text-indigo-700 border border-indigo-100';
      case Category.MAINTENANCE:
        return 'bg-cyan-50 text-cyan-700 border border-cyan-100';
      case Category.DEVICE:
        return 'bg-teal-50 text-teal-700 border border-teal-100';
      case Category.ACCESS:
        return 'bg-emerald-50 text-emerald-700 border border-emerald-100';
      default:
        return 'bg-gray-50 text-gray-700 border border-gray-100';
    }
  };

  // Format severity for display
  const formatSeverity = (severity) => {
    return severity; // Return the severity as is, maintaining the uppercase format
  };

  return (
    <td style={{ width: '338.47px' }} className="p-[30px]">
      <div className="text-sm font-medium text-gray-900">{event.description || 'No description'}</div>
      <div className="space-y-1 mt-1">
        <div className="flex items-center">
          <div className="text-sm text-gray-500 w-20">Severity:</div>
          <div className={`text-xs px-2 py-1 rounded font-medium ${getSeverityStyle(severity)}`}>
            {formatSeverity(severity)}
          </div>
        </div>
        <div className="flex items-center">
          <div className="text-sm text-gray-500 w-20">Category:</div>
          <div className={`text-xs px-2 py-1 rounded font-medium ${getCategoryStyle(category)}`}>
            {category.replace('_', ' ')}
          </div>
        </div>
      </div>
      {event.eventDetails?.yField?.description && (
        <div className="text-sm text-gray-500 break-words mt-1">
          Source: {event.eventDetails.yField.description}
        </div>
      )}
      {event.eventDetails?.zField?.description && (
        <div className="text-sm text-gray-500 break-words">
          Details: {event.eventDetails.zField.description}
        </div>
      )}
    </td>
  );
};

export default EventDetailsCell;